
import { Vue } from "vue-class-component";

export default class ChevronDownNew extends Vue {}
